module.exports = __webpack_public_path__ + "img/shape-1.5c69f4f3.svg";